import { colors } from "@everlywell/leaves"

export const cellType = {
  MARK: "mark",
  TIME: "time",
  ISSUE: "issue",
  CHECKBOX: "checkbox",
}

export const URL = {
  login: "/app/login",
  kitStatus: "/app/kit_status",
  settings: "/app/settings",
  admin: "/app/admin",
  accessCodes: "/app/admin/access_codes",
  createAccessCode: "/app/create-access-code",
  editAccessCode: "/app/edit-access-code/:code",
  registerKit: "/app/register-kit",
  userManagement: "/app/user-management",
  kitsDashboard: "/app/kits_dashboard",
  eligibilityFiles: "/app/admin/eligibility_files/",
  updatesFiles: "/app/admin/update_files/",
}

export const TABLE_MAX_ROWS = 50
export const TABLE_PAGER_COUNT = 5

export const STORAGE_REDIRECT = "redirect"
export const DEFAULT_REDIRECT = URL.kitStatus

// Query Status
export const queryStatus = {
  LOADING: "loading",
  ERROR: "error",
  SUCCESS: "success",
}

// Kit Status
export const KitStatusValue = {
  Ordered: "ordered", // Kit Result Status
  Registered: "registered", // Barcode State
  InTransit: "in_transit",
  Submitted: "pwn_submitted",
  Approved: "results_approved",
  Archived: "archived",
  Canceled: "cancelled",
  Retrievable: "retrievable_results",
  Processed: "processed", // Barcode State
  SampleCollected: "collected",
  ResultsEntered: "results_entered",
  Any: "any",
}

export const KitStatusDesc = {
  [KitStatusValue.Ordered]: {
    label: "Registered",
    color: colors.teal4,
    pointColor: colors.teal3,
  },
  [KitStatusValue.Registered]: {
    label: "Registered",
    color: colors.teal4,
    pointColor: colors.teal3,
  },
  [KitStatusValue.Submitted]: {
    label: "Registered",
    color: colors.teal4,
    pointColor: colors.teal3,
  },
  [KitStatusValue.InTransit]: {
    label: "In Transit to Lab",
    color: colors.teal5,
    pointColor: colors.teal4,
  },
  [KitStatusValue.Approved]: {
    label: "Results Released",
    color: colors.green5,
    pointColor: colors.green4,
  },
  [KitStatusValue.Archived]: {
    label: "Canceled",
    color: colors.gray4,
    pointColor: colors.gray2,
  },
  [KitStatusValue.Canceled]: {
    label: "Canceled",
    color: colors.gray4,
    pointColor: colors.gray2,
  },
  [KitStatusValue.Retrievable]: {
    label: "Received by Lab",
    color: colors.gray4,
    bgColor: colors.white,
    borderColor: colors.gray4,
    pointColor: colors.gray3,
  },
  [KitStatusValue.Processed]: {
    label: "Received by Lab",
    color: colors.gray4,
    bgColor: colors.white,
    borderColor: colors.gray4,
    pointColor: colors.gray3,
  },
  [KitStatusValue.SampleCollected]: {
    label: "Sample Collected",
    color: colors.orange3,
    pointColor: colors.orange3,
  },
  [KitStatusValue.ResultsEntered]: {
    label: "Results Entered",
    color: colors.green5,
    pointColor: colors.green4,
  },
}

export const InlineFilterDate = ["All", "Today", "Last 7 days", "Last 30 days"]

export const KitResultDesc = {
  Normal: "Normal",
  NeedsReview: "Needs Review",
}

export const KitResultColor = {
  Normal: "#e4f4ea",
  NormalBorder: "#b7d7c2",
  Invalid: "#fff3de",
  InvalidBorder: "#f7dfb7",
  NeedsReview: "#fcb9c1",
  NeedsReviewBorder: "#ff808e",
}

// Table Row Popup Menu
export const ROW_MENUS = {
  DETAILS: "Details",
  PDF: "Download PDF",
}

// Detail/Tracking/Transition
export const getTransitionDesc = to => {
  if (to === "processed") {
    return "Received by Lab"
  }
  return to
}

// Settings fragment
export const SETTINGS_FRAGMENT = {
  Profile: 0,
  Notifications: 1,
}

// Error
export const ERROR_TYPE = {
  NETWORK: "Network Error",
  INTERNAL_SYSTEM_ERROR: "Unable to verify eligibility",
  ACCESS_CODE: "Network Error",
  DOWNLOAD: "Unable to download",
  SUPER_ADMIN: "Super admin error",
  KIT_REGISTRATION: "We could not register this kit",
  MEMBER_NOT_FOUND: "Member details not found",
  MEMBER_NOT_ELIGIBLE: "Member is not eligible for this kit",
  MEMBER_ID_MISSING: "Member ID is required",
  ORDER_NUMBER_MISSING: "Unable to verify Order",
  PRODUCT_IDS_MISSING: "Unable to verify products",
}

export const ERROR_CONTENT = {
  NETWORK:
    "We are having some network issues at the moment. Please try again later.",
  SYSTEM:
    "We're experiencing some issues at the moment. Please try again later.",
  CREATE_ACCESS_CODE:
    "We can not create an access code at this time due to a network error. Please try again later.",
  UPDATE_ACCESS_CODE:
    "We can not update an access code at this time due to a network error. Please try again later.",
  PDF: "PDF can't be downloaded due to empty content.",
  NO_RESULT: "The result PDF is not available at this time.",
  NO_USER_FOUND: "This email does not exist.",
  INVALID_EMAIL: "Please input email correctly.",
  CANNOT_MIMIC_SUPERADMIN: "Can't mimic another super admin.",
  CANNOT_MIMIC_YOURSELF: "Can't mimic yourself.",
  KIT_REGISTRATION:
    "We can not register this kit at this time due to a network error. Please try again later.",
  MEMBER_NOT_FOUND: "If you need help, please call Everlywell 855-463-1670",
  MEMBER_NOT_ELIGIBLE: "If you need help, please call Everlywell 855-463-1670",
}

// Toast Message
export const TOAST_MSG = {
  PDF_DOWNLOADED: "Downloaded",
  CSV_EXPORTED: "Exported",
  DOWNLOAD_COMPLETE: "Download completed",
  CODE_SAVED: "Saved",
  CODE_CREATED: "Access Code created",
  KIT_REGISTERED: "Kit registered",
  CLIA_WAIVER_ENTERED: "Successfully entered CLIA Waiver Number",
  RESULT_ADDED: "You succesfully added {result} results for kit ID {kit_id}",
  DOWNLOAD_IN_PROGRESS: "Download in progress",
  DOWNLOAD_MAX_REACHED: "Download Maximum Exceeded",
  DOWNLOAD_ERROR: "Download Error"
}

export const TOAST_DESC = {
  PDF_DOWNLOADING: "Result PDF is downloading.",
  CSV_EXPORTED: "Test Kits has been exported.",
  CODE_SAVED: "This access code has been updated.",
  CODE_CREATED: "This code will be ready to use.",
  KIT_REGISTERED: "This kit has been successfully registered.",
  CLIA_WAIVER_ENTERED: "",
  RESULT_ADDED: "You have 60 seconds to change this selection.",
}

export const TOAST_IDS = {
  ALL_ENTRIES_SELECTED: "all_entries_toast",
  PAGE_ENTRIES_SELECTED: "page_entries_toast",
}

export const SEARCH_CELL_KEYS = ["id", "status", "name", "test"]

export const HASURA_ROLE = {
  partner: "enterprise_partner_clinical_admin",
  partner_hcp: "enterprise_partner_hcp",
  partner_non_phi: "enterprise_partner_non_phi_admin",
  client: "enterprise_client_clinical_admin",
  client_hcp: "enterprise_client_hcp",
  client_non_phi: "enterprise_client_non_phi_admin",
  access: "access_code_admin",
  superAdmin: "everlywell_super_admin",
}

export const HASURA_ROLES_DICTIONARY = {
  enterprise_client_admin: "Admin",
  enterprise_partner_admin: "Admin",
  enterprise_client_hcp: "Health Care Provider",
  enterprise_partner_hcp: "Health Care Provider",
  enterprise_client_clinical_admin: "Clinical Admin",
  enterprise_partner_clinical_admin: "Clinical Admin",
  enterprise_client_non_phi_admin: "Admin (no PII access)",
  enterprise_partner_non_phi_admin: "Admin (no PII access)",
  everlywell_super_admin: "EHS Super Admin",
}

export const FAKE_ROW_COUNT = 10

export const FULFILLMENT_PROVIDERS = {
  rrd: {
    formatKitId: kitId => {
      return kitId.replace(/(.{3})(.{3})(.{3})/g, "$1-$2-$3")
    },
  },
  spectrum: {
    formatKitId: kitId => {
      return kitId.replace(/(.{3})(.{3})(.{3})/g, "$1-$2-$3")
    },
  },
  gbf: {
    formatKitId: kitId => {
      return kitId.replace(/(?:kit_|)(.{3})(.{4})(.{4})(?:.*)/g, "$1-$2-$3")
    },
  },
  path_tec: {
    formatKitId: kitId => {
      return kitId.replace(/(.{3})(.{4})(.{4})/g, "$1-$2-$3")
    },
  },
  home_access: {
    formatKitId: kitId => {
      const oldBarcodeRegex = /^(61|33)/

      if (oldBarcodeRegex.test(kitId)) {
        return kitId.replace(/(.{3})(.{3})(.{3})/g, "$1-$2-$3")
      }

      return kitId.replace(/(.{4})(.{4})(.{4})/g, "$1-$2-$3")
    }
  }
}

export const DEFAULT_SEARCH_COLUMNS = {
  kit_id: true,
  kit_status: true,
  participant: true,
  test_name: true,
  third_party_member_id: true,
  partner_membership_member_id: true
}

export const NON_PHI_SEARCH_COLUMNS = {
  kit_id: true,
  test_name: true,
  kit_status: true,
}

export const DEFAULT_COLUMN_PREFERENCE = {
  client: true,
  kit_id: true,
  kit_status: true,
  participant: true,
  date_of_birth: false,
  email: false,
  third_party_member_id: false,
  phone: false,
  ordered: false,
  registered: true,
  collected: false,
  received_by_lab: true,
  results_entered_at: false,
  results_entered: false,
  sample_issue: false,
  results_released: true,
  participant_viewed_at: false,
  test_name: true,
  result: true,
  enterprise_program_name: false,
}

export const NON_PHI_ADMIN_COLUMN_PREFERENCE = {
  client: true,
  kit_id: true,
  kit_status: true,
  ordered: false,
  registered: true,
  collected: false,
  received_by_lab: true,
  results_entered_at: false,
  results_entered: false,
  sample_issue: false,
  results_released: true,
  participant_viewed_at: false,
  test_name: true,
  result: true,
  enterprise_program_name: false,
}

export const HCP_COLUMN_PREFERENCE = {
  participant: true,
  kit_id: true,
  kit_status: true,
  registered: true,
  collected: true,
  results_entered: true,
  results_released: true,
}

export const DISABLED_COLUMNS = ["kit_id", "kit_status", "result"]

export const SUPPORT_PDF_URL =
  "https://everly-well.s3-us-west-2.amazonaws.com/assets/Everlywell_Lens_Quick_Guide.pdf"

export const SAMPLE_COLLECTION_VIDEO_URL =
  "https://support.everlywell.com/article/507-sample-collection-videos"

export const DELIVERY_OPTIONS = [
  {
    id: 7,
    title: "USPS Standard Shipping",
    description: "Estimated 1-3 business days",
  },
  {
    id: 12,
    title: "UPS Overnight Shipping",
    description: "Estimated next business day",
  },
  {
    id: 13,
    title: "UPS Ground Shipping",
    description: "Estimated 1-7 business days",
  },
]

export const PAYMENT_OPTIONS_RADIO_BUTTONS = [
  { name: "enterprise_client_paid", label: "Enterprise Client" },
  { name: "test_taker_paid", label: "Test Taker" }
]

export const RACES = [
  {
    value: "American Indian or Alaska Native",
  },
  {
    value: "Asian",
  },
  {
    value: "Black or African American",
  },
  {
    value: "Native Hawaiian or Other Pacific Islander",
  },
  {
    value: "Two or More Races",
  },
  {
    value: "White",
  },
  {
    value: "Other",
  },
  {
    value: "Prefer Not To Answer",
  },
]

export const ETHNICITIES = [
  {
    value: "Latino or Hispanic",
  },
  {
    value: "Not Latino or Hispanic",
  },
  {
    value: "Prefer Not To Answer",
  },
]

export const SYMPTOMS_LABELS = {
  "no symptoms": "No symptoms or symptoms not listed",
  mild: `One or more of the following symptoms: fever, cough sore throat, runny or stuffy nose,
    shortness of breath that is not limiting his or her ability to speak, diarrhea, nausea or vomiting,
    feeling tired, headache, body aches, belly pain, new loss of taste or smell, low appetite`,
  severe: `One or more of the following symptoms: a fever that is accompanied by a rash,
    a temperature of 100.3°F or higher for more than 48 hours, or a temperature of 102.2°F despite
    using fever-reducing medications, appears ill or is acting unusual or less active than normal,
    less appetite than normal over the past 48 hours`,
}

export const EXPOSURE_LABELS = {
  "not exposed": "They have not been exposed to COVID-19",
  "area community spread": `They live in or have visited a place where people reside, meet, or gather in close proximity
    (includes group homes, homeless shelters, detention centers, playgroups, schools, church, camp, daycare, etc.)`,
  "sick contact":
    "Participant's school or public health department has requested participant get tested.",
  "known exposure": `Participant has been in close proximity to someone who has been diagnosed with or presumed to have COVID-19.
    Close proximity is defined as (within 6 ft of the person for a total of 15 minutes over a 24-hour period or
    been coughed or sneezed on)`,
}

export const VACCINE_TYPES = {
  moderna: "Moderna",
  pfizer: "Pfizer",
  other: "Other",
}

export const VACCINE_DOSES = {
  "one-dose": "1 dose",
  "two-doses": "2 doses",
}

export const US_STATES = [
  { value: "Select State", id: "default-select", text: "Select State" },
  { value: "AL", id: "AL", text: "Alabama" },
  { value: "AK", id: "AK", text: "Alaska" },
  { value: "AZ", id: "AZ", text: "Arizona" },
  { value: "AR", id: "AR", text: "Arkansas" },
  { value: "CA", id: "CA", text: "California" },
  { value: "CO", id: "CO", text: "Colorado" },
  { value: "CT", id: "CT", text: "Connecticut" },
  { value: "DE", id: "DE", text: "Delaware" },
  { value: "DC", id: "DC", text: "District Of Columbia" },
  { value: "FL", id: "FL", text: "Florida" },
  { value: "GA", id: "GA", text: "Georgia" },
  { value: "HI", id: "HI", text: "Hawaii" },
  { value: "ID", id: "ID", text: "Idaho" },
  { value: "IL", id: "IL", text: "Illinois" },
  { value: "IN", id: "IN", text: "Indiana" },
  { value: "IA", id: "IA", text: "Iowa" },
  { value: "KS", id: "KS", text: "Kansas" },
  { value: "KY", id: "KY", text: "Kentucky" },
  { value: "LA", id: "LA", text: "Louisiana" },
  { value: "ME", id: "ME", text: "Maine" },
  { value: "MD", id: "MD", text: "Maryland" },
  { value: "MA", id: "MA", text: "Massachusetts" },
  { value: "MI", id: "MI", text: "Michigan" },
  { value: "MN", id: "MN", text: "Minnesota" },
  { value: "MS", id: "MS", text: "Mississippi" },
  { value: "MO", id: "MO", text: "Missouri" },
  { value: "MT", id: "MT", text: "Montana" },
  { value: "NE", id: "NE", text: "Nebraska" },
  { value: "NV", id: "NV", text: "Nevada" },
  { value: "NH", id: "NH", text: "New Hampshire" },
  { value: "NJ", id: "NJ", text: "New Jersey" },
  { value: "NM", id: "NM", text: "New Mexico" },
  { value: "NY", id: "NY", text: "New York" },
  { value: "NC", id: "NC", text: "North Carolina" },
  { value: "ND", id: "ND", text: "North Dakota" },
  { value: "OH", id: "OH", text: "Ohio" },
  { value: "OK", id: "OK", text: "Oklahoma" },
  { value: "OR", id: "OR", text: "Oregon" },
  { value: "PA", id: "PA", text: "Pennsylvania" },
  { value: "RI", id: "RI", text: "Rhode Island" },
  { value: "SC", id: "SC", text: "South Carolina" },
  { value: "SD", id: "SD", text: "South Dakota" },
  { value: "TN", id: "TN", text: "Tennessee" },
  { value: "TX", id: "TX", text: "Texas" },
  { value: "UT", id: "UT", text: "Utah" },
  { value: "VT", id: "VT", text: "Vermont" },
  { value: "VA", id: "VA", text: "Virginia" },
  { value: "WA", id: "WA", text: "Washington" },
  { value: "WV", id: "WV", text: "West Virginia" },
  { value: "WI", id: "WI", text: "Wisconsin" },
  { value: "WY", id: "WY", text: "Wyoming" },
]

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const DEFAULT_KIT_REGISTER_MIN_AGE = 18

export const HUMANA = 5

export const MIXPANEL_TAGS = {
  category: "lens",
  page_viewed: "Page Viewed",
  cta_clicked: "CTA Clicked",
  error_presented: "Error Presented",
  success_message_presented: "Success Message Presented",
  access_codes: {
    page_name: "access_codes",
    created: "Access Code Created",
  },
  groups: {
    created: "Group Added",
    page_name: "groups_table",
    add_modal_page_name: "add_group_modal",
    category: "lens_user_management",
  },
  users: {
    created: "User Added",
    page_name: "users_table",
    add_modal_page_name: "add_user_modal",
    category: "lens_user_management",
  },
  kits_table: {
    page_name: "test_kit_home",
    category: "lens_kit_table",
    detail_page_name: "kit_details_page",
  },
  dashboard: {
    page_name: "kits_dashboard",
    category: "lens_kit_dashboard",
  },
  eligibility_imports: {
    page_name: "eligibility_imports",
    category: "lens_eligibility_imports",
  },
  updates_imports: {
    page_name: "updates_imports",
    category: "lens_updates_imports",
  },
}

export const PHI_ACCESS_DESCRIPTION = "They have immediate access to PII"
export const NON_PHI_ACCESS_DESCRIPTION = "They do not have access to PII"

export const VACCINATED = {
  YES: "is_vaccinated",
  NO: "is_not_vaccinated",
  NO_ANSWER: "prefer_not_to_answer",
}

export const ELIGIBILITY_FILE_PREFIX = "data-ingestion/eligibility/"

export const ADDRESS_VALIDATION = {
  confirmation_with_errors: {
    title: "Verify Address Details",
    sub_title: "The address you entered is not valid. Do you wish to move forward with this address?",
    input: "You entered:",
    actions: {
      confirm: "Use address",
      edit: "Edit address",
    }
  },
  confirmation_with_suggestions: {
    title: "Verify Your Address",
    sub_title: "The address you entered may be incorrect or incomplete. Please review our suggestion and choose the version you'd like to use.",
    input: "You entered:",
    single_suggestion_input: "Suggested address:",
    multiple_suggestions_input: "Suggested addresses:",
    actions: {
      confirm: "Use selected address",
      edit: "Edit address",
    }
  }
}